<!--Componente para mostrar los boletos de los eventos disponibles-->
<template>
  <v-row justify="center" class="elevation-2 pa-5">
    <v-col cols="12">
      <h2 class="headline font-weight-bold">Inventario de boletos</h2>
      <v-divider></v-divider>
       <!-- CONTENIDO DE LA TABLA -->
      <v-data-table
        no-data-text="No hay datos disponibles."
        no-results-text="No hay datos disponibles."
        loading-text="Cargando datos..."
        class="table-header"
        :headers="ticketsHeaders"
        :items="tickets"
        :items-per-page="($vuetify.breakpoint.xsOnly)?3:6"
        :loading="loading"
        :header-props="{
          sortByText:'Ordenar por'
        }"
        :footer-props="{
          itemsPerPageText: 'Filas por página',
          itemsPerPageAllText:'Todas',
        }"
      >
        <template v-slot:body="{items}">
          <tbody>
            <tr v-for="(item, index) in items" :key="index" class="text-center" :class="[(item.quantity<=0)?'sold-out-color':(item.quantity<=(item.tickets*0.2))?'low-color':'', ($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-table-row':'' ]">
              <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''" >
                <div class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none">
                  {{ticketsHeaders[0].text}}
                </div>
                <div :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''">
                  {{item.eventName}}
                </div>
              </td>
              <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''" >
                <div class="font-weight-bold v-data-table__mobile-row__header d-flex d-sm-none">
                  {{ticketsHeaders[1].text}}
                </div>
                <div :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''">
                  {{item.productName}}
                </div>
              </td>
              <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''" >
                <div class="font-weight-bold v-data-table__mobile-row__header d-flex d-sm-none">
                  {{ticketsHeaders[2].text}}
                </div>
                <div :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''">
                  <v-chip class="pointer" color="secondary" dark>{{ item.tickets }}</v-chip>
                </div>
              </td>
              <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''" >
                <div class="font-weight-bold v-data-table__mobile-row__header d-flex d-sm-none">
                  {{ticketsHeaders[3].text}}
                </div>
                <div :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''">
                  <v-chip class="pointer" color="success" dark>{{ item.quantity }}</v-chip>
                </div>
              </td>
              <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''" >
                <div class="font-weight-bold v-data-table__mobile-row__header d-flex d-sm-none">
                  {{ticketsHeaders[4].text}}
                </div>
                <div :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''">
                  <v-chip color="accent" dark>{{ item.sold }}</v-chip>
                </div>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>

      <!-- DIALOG PARA LA ELIMINACIÓN DE UN BOLETO EN ESPECÍFICO -->
      <v-dialog v-if="deleteDialog" v-model="deleteDialog" width="500" overlay-opacity="0.2">
        <v-card>
          <v-card-title>
            <h2 class="title">¿Estás seguro de querer eliminar el boleto?</h2>
          </v-card-title>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="deleteDialog = false">Cancelar</v-btn>
            <v-btn color="error" depressed @click="confirmTicketDelete()">Eliminar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>
<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      deleteDialog: false,
      loading: false,
      selectedItem: {},
      ticketsHeaders: [
        { align: 'center', text: "Evento", value: "eventName" },
        { align: 'center', text: "Boleto", value: "productName" },
        { align: 'center', text: "Total de boletos",  width: "120px" , value: "tickets" },
        { align: 'center', text: "Disponibles", value: "quantity" },
        { align: 'center', text: "Vendidos", value: "sold" }
      ],
      tickets: []
    };
  },
  computed: {
    ...mapState("order", ["ticketsInventory"])
  },
  methods: {
    ...mapActions("order", ["deleteTicket", "fetchTicketsInventory"]),
    // deleteTicket(item) {
    //   this.deleteDialog = true;
    //   this.selectedItem = item;
    // },
    // async confirmTicketDelete() {
    //   this.deleteDialog = false;
    // },

     /**
     * Función para dar formato al objeto de la base de datos para su uso en la data table.
     */
    async formatData() {
      this.loading = true;
      await this.fetchTicketsInventory();
      this.tickets = this.ticketsInventory.map(ticket => {
        let ticketAvailable;
        if (ticket.inventory.inventoryType === "INFINITE") {
          ticket.inventory.quantity = "N/D";
          ticketAvailable = "N/D";
        } else {
          ticketAvailable = ticket.inventory.quantity - ticket.inventory.sold;
        }

        return {
          id: ticket.id,
          eventName: ticket.event.name,
          productName: ticket.name,
          tickets: ticket.inventory.quantity,
          quantity: ticketAvailable,
          sold: ticket.inventory.sold
        };
      });
      this.loading = false;
    },
  },
  async mounted() {
    await this.formatData();
  }
};
</script>
<style scoped>
@media (min-width: 1264px) {
  td{
    width: 50px;
  }
}
.table-header >>> thead {
  background-color: rgb(231, 231, 231);
}
.low-color{
  background-color:rgba(248, 236, 73, 0.2)
}
.sold-out-color{
  background-color:rgba(218, 81, 81, 0.2)
}

</style>
